import React from "react";
import { Icon } from "@src/components/atoms";
import { useOperatorContext } from "@src/context/operatorContext";
import { useDCContext } from "@src/context";
import OperatorHooks from "@src/context/hooks/operatorHooks";

const GDPRReminder = () => {
  const { profile, setProfile, gdprOpen, setGdprOpen } = useOperatorContext();
  const { getDynamicReplacement } = useDCContext();

  const mutationCallback = (profileData, status) => {
    profileData && setProfile(profileData);
  };
  const mutation = OperatorHooks.useSubmitOperatorProfile(mutationCallback);

  if (!profile) return null;

  const onSubmit = () => {
    const request = {
      firstname: profile.appUser.firstname,
      lastname: profile.appUser.lastname,
      dataPrivacyAgreement: new Date(),
      dataPrivacyAgreementSigned: true,
    };
    mutation.mutateAsync(request);
    /*const responseMessage = getDynamicReplacement(
      "captain__gdpr_reminder__thanks"
    );*/
    setGdprOpen(false);
  };

  return (
    <div>
      {gdprOpen && (
        <div className="px-4">
          <div className="z-60 w-11/12 max-w-7xl rounded-2xl br-2 border-2 bg-gray-100 border-primary-600 text-base text-left p-6 lh-1 fixed bottom-6 left-1/2 transform -translate-x-1/2 shadow-xl">
            <div onClick={() => onSubmit()}>
              <Icon
                name="close"
                backgroundColor="transparent"
                size="sm"
                textColor="black"
                centered={false}
                padding={false}
                className="ml-auto"
              />
            </div>
            <div className="text-primary-500 font-bold">
              {getDynamicReplacement("captain__gdpr_reminder__title")}
            </div>
            <div className="text-black text-sm py-2">
              {getDynamicReplacement("captain__gdpr_reminder__message")}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GDPRReminder;
